import type { InjectionKey } from 'vue';
import type { VisualizationAgentClient } from './VisualizationAgentClient.ts';
import { inject } from 'vue';

export const visualizationAgentClientKey:
InjectionKey<VisualizationAgentClient> = Symbol('visualization-agent-client');

export function useVisualizationAgentClient():
VisualizationAgentClient | null {
  return inject(visualizationAgentClientKey, null);
}
